import { render } from "./LastGames.vue?vue&type=template&id=d60b1c96&scoped=true"
import script from "./LastGames.vue?vue&type=script&lang=js"
export * from "./LastGames.vue?vue&type=script&lang=js"

import "./LastGames.vue?vue&type=style&index=0&id=d60b1c96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d60b1c96"]])

export default __exports__